import type { Currency } from "./types";

export function money(value: string | number | null | undefined, currency: Currency, places = 2): string {
  if (value === null || value === undefined || value === "") return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency, minimumFractionDigits: places, maximumFractionDigits: places }).format(Number(value));
}

/** A percentage the engine already expressed in points (36.00 = +36 %). */
export function pctPoints(value: string | number | null | undefined, places = 0): string {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  return `${number > 0 ? "+" : ""}${number.toFixed(places)} %`;
}

/** The narrow symbol the en-GB formatter prints for a currency (£, €, AED, $), for labels that name the currency without a value. */
export function currencySymbol(currency: string): string {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency, currencyDisplay: "narrowSymbol", maximumFractionDigits: 0 }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
}
